function ProfileIcon2() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
      className='profile-icon'
      style={{ marginRight: '3px' }}
    >
      <path
        fill='#5A6675'
        d='M8.009 6.5c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm5.991 6h-4c-4.06 0-5.5 2.973-5.5 5.519 0 2.277 1.211 3.481 3.503 3.481h7.994c2.292 0 3.503-1.204 3.503-3.481 0-2.546-1.44-5.519-5.5-5.519z'
      />
    </svg>
  );
}

export default ProfileIcon2;
